import { render, staticRenderFns } from "./TrainingDetailsModule.vue?vue&type=template&id=6a6d6f5c&scoped=true&"
import script from "./TrainingDetailsModule.vue?vue&type=script&lang=js&"
export * from "./TrainingDetailsModule.vue?vue&type=script&lang=js&"
import style0 from "./TrainingDetailsModule.vue?vue&type=style&index=0&id=6a6d6f5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6d6f5c",
  null
  
)

export default component.exports